import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Youtube, MessageCircle } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const quickLinks = [
    { key: 'home', href: '#home' },
    { key: 'aboutUs', href: '#about' },
    { key: 'products', href: '#products' },
    { key: 'careers', href: '#careers' },
    { key: 'distributorEnquiry', href: '#distributor' },
    { key: 'salesmanApplication', href: '#salesman' },
    { key: 'contact', href: '#contact' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="logo-text mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_gupta-grih-udyog/artifacts/rao6ba83_generated-image.png" 
                alt="Gupta Soap Logo" 
                className="h-12 w-auto mb-3"
              />
              <span className="text-xl font-black text-white tracking-tight block">Gupta Soap Grih Udyog</span>
              <span className="block text-xs font-medium text-slate-400 tracking-wide">Since 1973</span>
            </div>
            <p className="text-slate-400 text-sm mb-4">
              ISO 9001:2015 & MSME ZED Certified manufacturer of detergents and cleaning products since 1973.
            </p>
            <div className="flex items-center gap-2 text-slate-400 text-sm">
              <MapPin className="w-4 h-4" />
              <span>Kanpur, Uttar Pradesh</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">{t('quickLinks')}</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.key}>
                  <a 
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                    data-testid={`footer-link-${link.key}`}
                  >
                    {t(link.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">{t('contact')}</h4>
            <div className="space-y-4">
              <a href="tel:9919091190" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4" />
                <span className="text-sm">99190-91190</span>
              </a>
              <a href="mailto:customercare@guptasoap.com" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4" />
                <span className="text-sm">customercare@guptasoap.com</span>
              </a>
              <div className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  179-B Dadanagar, Co-Operative Industrial Estate, Kanpur – 208022, U.P., India
                </span>
              </div>
            </div>
          </div>

          {/* Social & Company Details */}
          <div>
            <h4 className="text-lg font-bold mb-6">{t('followUs')}</h4>
            <div className="flex gap-3 mb-6">
              <a href="https://wa.me/919919091190" target="_blank" rel="noopener noreferrer" className="social-icon" data-testid="footer-whatsapp">
                <MessageCircle className="w-5 h-5" />
              </a>
              <a href="#" className="social-icon" data-testid="footer-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="social-icon" data-testid="footer-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="social-icon" data-testid="footer-linkedin">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="social-icon" data-testid="footer-youtube">
                <Youtube className="w-5 h-5" />
              </a>
            </div>

            <h5 className="font-semibold text-sm mb-3">{t('companyDetails')}</h5>
            <div className="text-slate-400 text-sm space-y-1">
              <p><span className="text-slate-500">{t('gstNo')}:</span> 09ACZPG0691C1ZD</p>
              <p><span className="text-slate-500">{t('udyamNo')}:</span> UDYAM-UP-43-0031365</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-slate-500 text-xs">
            <div className="text-center md:text-left">
              <p className="mb-1">{t('trademark')}</p>
              <p>{t('copyright')}</p>
            </div>
            <p>© 2026 Gupta Soap Grih Udyog. {t('allRights')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
